module.exports = __webpack_public_path__ + "img/Zugführer.26207add.svg";